require.register("modules/m03s/m03s-activity/page-7/page-7", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page7 = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {

  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page7;

  
});

